'use client'
import React from 'react'
import { faHome, faExclamationCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as Sentry from "@sentry/nextjs"
import { useEffect } from "react"

import '@/styles/system-pages/system.module.scss'
import '@/styles/system-pages/error.scss'

const ErrorPage = ({
  error,
}: {
  error: Error & { digest?: string };
}) => {

  useEffect(() => {
    Sentry.captureException(error);
  }, [error])

  return (
    <html lang="en">
      <body>
        <section className="error-container">
          <div className="error-content">
            <h1 className="error-title">
              <FontAwesomeIcon icon={faExclamationCircle} />
            </h1>
            <h2 className="error-subtitle">An error occurred</h2>
            <div className="error-link" onClick={() => window.location.reload()}>
              <FontAwesomeIcon icon={faHome} />
              <span>Go back to home</span>
            </div>
          </div>
        </section>
      </body>
    </html>
  )
}

export default ErrorPage